import cn from "classnames";

const Card = ({className, children}) => (
  <div className={cn("bg-codGray border-t-4 border-[#262626] rounded-lg", className)}>
    {children}
  </div>
);


export default Card;